
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { History, Brain } from "lucide-react";
import CurrentAffairsHistory from './CurrentAffairsHistory';
import CurrentAffairsAdaptiveQuizContent from './CurrentAffairsAdaptiveQuizContent';
import { useIsMobile } from "@/hooks/use-mobile";

const AdaptiveCurrentAffairsQuiz = () => {
  const { isMobile, isSmallMobile, screenSize } = useIsMobile();
  
  return (
    <div className={`container mx-auto ${isSmallMobile ? 'p-1 pb-20' : isMobile ? 'p-2 pb-24' : 'p-4'} max-w-7xl`}>
      <Tabs defaultValue="quiz" className="w-full">
        <TabsList className={`${isSmallMobile ? 'mb-1.5' : isMobile ? 'mb-2' : 'mb-4'} ${isMobile ? 'w-full' : ''}`}>
          <TabsTrigger 
            value="quiz" 
            className={`flex items-center gap-1 sm:gap-2 ${isSmallMobile ? 'text-[10px] py-0.5 px-1.5' : isMobile ? 'text-xs py-1' : 'text-sm'}`}
          >
            <Brain className={`${isSmallMobile ? 'h-2 w-2' : isMobile ? 'h-2.5 w-2.5' : 'h-4 w-4'}`} />
            Adaptive Quiz
          </TabsTrigger>
          <TabsTrigger 
            value="history" 
            className={`flex items-center gap-1 sm:gap-2 ${isSmallMobile ? 'text-[10px] py-0.5 px-1.5' : isMobile ? 'text-xs py-1' : 'text-sm'}`}
          >
            <History className={`${isSmallMobile ? 'h-2 w-2' : isMobile ? 'h-2.5 w-2.5' : 'h-4 w-4'}`} />
            History
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="quiz">
          <CurrentAffairsAdaptiveQuizContent />
        </TabsContent>
        
        <TabsContent value="history">
          <CurrentAffairsHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdaptiveCurrentAffairsQuiz;
